module.exports = __webpack_public_path__ + "img/drawblindbox.5eec3f65.png";